import React, { memo } from "react";
import styles from "./styles.module.scss";
import GettingStartedProgress from "app/components/GettingStarted/GettingStartedProgress";
import { useTranslation } from "react-i18next";
import Navbar from "app/components/Navbar";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";
import Tabs from "app/components/Tabs";
import { hasAcademyPlan } from "app/utils/subscription";

interface Props {
  children: React.ReactNode;
}

const ActivityLayout = ({ children }: Props) => {
  const { t } = useTranslation();
  const { totalUnseen } = useSelector((state: RootState) => state.notification);
  const user = useSelector((state: RootState) => state.user.data);

  const sidebarItems = [
    {
      label:
        t("Notifications") +
        (totalUnseen?.notifications > 0
          ? ` (${totalUnseen?.notifications})`
          : ""),
      path: "/activity/notifications",
    },
    {
      label:
        t("Invitations") +
        (totalUnseen?.invitations > 0 ? ` (${totalUnseen?.invitations})` : ""),
      path: "/activity/invitations",
    },
    ...(user && hasAcademyPlan(user)
      ? [
          {
            label: t("Booking Logs"),
            path: "/activity/booking_logs",
          },
        ]
      : []),
  ];

  return (
    <>
      <Navbar
        label={t("Activity")}
        hasNotifications={false}
        hasSearch={false}
      />
      <h2 className={styles.home_navbar_title_mobile}>{t("Activity")}</h2>
      <Tabs tabs={sidebarItems} />
      <div className={styles.container}>
        <div className={styles.main}>
          <GettingStartedProgress />
          <div className={styles.content_wrapper}>{children}</div>
        </div>
      </div>
    </>
  );
};

export default memo(ActivityLayout);
